import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Destination } from '@app/models';
import { environment } from '@environments/environment';

const API = environment.API;
@Injectable({
  providedIn: 'root'
})
export class DestinationService {
  constructor(private http: HttpClient) {}

  get() {
    return this.http.get<Destination[]>(`${API}destinations`);
  }

  create(destination: Destination) {
    return this.http.post<Destination>(`${API}destinations`, destination);
  }
  delete(IdDestination: number) {
    return this.http.put<Destination>(`${API}destinations/delete`, {"IdDestination":IdDestination});
  }
  update(IdDestination: number,data: Destination) {
    return this.http.put<Destination>(`${API}destinations/${IdDestination}`,data);
  }
}
